import styled from 'styled-components';

export const TransactionLimitFormLink = styled.a<{ $doubleMargin?: boolean }>`
  text-align: right;
  font-size: var(--cc_size_text_xs);
  font-weight: 400;
  color: var(--cc_color_utility_info);
  line-height: 1.2;
  margin-top: ${(props) => (props.$doubleMargin ? '-36px' : '-16px')};
  z-index: 1;
`;

export default TransactionLimitFormLink;
